var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c("v-autocomplete", {
        attrs: {
          items: _vm.policiesWithNew,
          required: this.field.required,
          disabled: this.field.disabled,
          outlined: "",
          dense: "",
        },
        on: { change: _vm.onPolicyChange },
        model: {
          value: _vm.input,
          callback: function ($$v) {
            _vm.input = $$v
          },
          expression: "input",
        },
      }),
      _vm._v(" "),
      _vm.showAddCustomPolicy
        ? _c(
            "v-card",
            { staticClass: "mt-2 mb-2 pa-3" },
            [
              _c("v-card-title", { staticClass: "subtitle-1" }, [
                _vm._v("New Policy"),
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "font-weight-bold caption mb-1",
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c("v-col", { attrs: { cols: "6" } }, [_vm._v("Amount")]),
                      _vm._v(" "),
                      _c("v-col", { attrs: { cols: "6" } }, [_vm._v("When")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.scheduleRows, function (scheduleRow, index) {
                    return _c(
                      "v-row",
                      {
                        key: index,
                        staticClass: "mb-2",
                        attrs: { "no-gutters": "", align: "center" },
                      },
                      [
                        _c(
                          "v-col",
                          { staticClass: "pr-2", attrs: { cols: "6" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                placeholder:
                                  index === 0
                                    ? "e.g. 35% of total"
                                    : index === _vm.scheduleRows.length - 1
                                    ? "Final balance"
                                    : "",
                                outlined: "",
                                dense: "",
                                "hide-details": "",
                              },
                              model: {
                                value: scheduleRow.amount,
                                callback: function ($$v) {
                                  _vm.$set(scheduleRow, "amount", $$v)
                                },
                                expression: "scheduleRow.amount",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { staticClass: "pr-2", attrs: { cols: "5" } },
                          [
                            _c(
                              "v-row",
                              { attrs: { "no-gutters": "", align: "center" } },
                              [
                                _c(
                                  "v-col",
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.whenOptions,
                                        outlined: "",
                                        dense: "",
                                        "hide-details": "",
                                      },
                                      model: {
                                        value: scheduleRow.when,
                                        callback: function ($$v) {
                                          _vm.$set(scheduleRow, "when", $$v)
                                        },
                                        expression: "scheduleRow.when",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                scheduleRow.when === "days_before"
                                  ? _c(
                                      "v-col",
                                      {
                                        staticClass: "pl-2 d-flex align-center",
                                        attrs: { cols: "auto" },
                                      },
                                      [
                                        _c("v-text-field", {
                                          staticStyle: { width: "80px" },
                                          attrs: {
                                            type: "number",
                                            min: "1",
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                          },
                                          model: {
                                            value: scheduleRow.days,
                                            callback: function ($$v) {
                                              _vm.$set(scheduleRow, "days", $$v)
                                            },
                                            expression: "scheduleRow.days",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ml-2 body-2 grey--text text--darken-1",
                                          },
                                          [_vm._v("days before arrival")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-col",
                          { staticClass: "text-center", attrs: { cols: "1" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  icon: "",
                                  small: "",
                                  disabled: _vm.scheduleRows.length === 1,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeScheduleRow(index)
                                  },
                                },
                              },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("close"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { small: "", text: "" },
                      on: { click: _vm.addScheduleRow },
                    },
                    [_vm._v("+ Add row")]
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.allowTextEdit
        ? _c(
            "v-btn",
            {
              attrs: {
                icon: "",
                small: "",
                title: _vm.editText
                  ? "Lock policy text"
                  : "Manually edit policy text",
              },
              on: {
                click: function ($event) {
                  _vm.editText = !_vm.editText
                },
              },
            },
            [
              _c("v-icon", { attrs: { small: "" } }, [
                _vm._v(_vm._s(_vm.editText ? "lock_open" : "lock")),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-textarea", {
        attrs: {
          required: this.field.required,
          disabled: this.field.disabled || !_vm.editText || !_vm.allowTextEdit,
        },
        model: {
          value: _vm.text,
          callback: function ($$v) {
            _vm.text = $$v
          },
          expression: "text",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }